export enum HeaderModalOptions {
  SIGN_IN = 'sign_in',
  RESEND_EMAIL_VERIFICATION_LINK = 'resend_email_verification_link',
  FORGOT_PASSWORD = 'forgot_password',
  CREATE_PASSWORD = 'create_password',
  SIGN_UP = 'sign_up',
  SET_UP_ACCOUNT = 'set_up_account',
  CREATE_LOCATION = 'create_location',
  SWITCH_USERS = 'switch_users',
}

export const TRIGGER_MODAL_OPEN_PARAM = 'trigger';

export const TRIGGER_MODAL_OPEN_MAP = {
  [HeaderModalOptions.SIGN_IN]: 'login',
  [HeaderModalOptions.CREATE_PASSWORD]: 'recover-password',
  [HeaderModalOptions.SIGN_UP]: 'create-account',
  [HeaderModalOptions.SET_UP_ACCOUNT]: 'setup-account',
};
